import {Component, Input, OnInit} from '@angular/core';
import { Monitoring } from '../../../model/monitoring';
import {MonitoringStepStatus} from "../../../constants/monitoring-step-status";

@Component({
  selector: 'tx-monitoring-step',
  templateUrl: './monitoring-step.component.html',
  styleUrls: ['./monitoring-step.component.css']
})
export class MonitoringStepComponent implements OnInit {
  _monitoring: Monitoring;

  constructor() {
  }

  ngOnInit() {
  }

  @Input()
  set monitoring(monitoring) {
    this._monitoring = monitoring;
  }

  get monitoring() {
    return this._monitoring;
  }

  isCurrentStep(step: MonitoringStepStatus) {
    if (step)
      return step === MonitoringStepStatus.CURRENT;
    return false;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/monitoring/step/monitoring-step.component.ts